<template>
    <el-dialog
        title="上传资料" :visible.sync="dialogVisible" width="630px" :before-close="beforeClose" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
            <el-form-item label="资料名称">
                <el-input placeholder="请输入资料名称，不输则默认为文件名" v-model="ruleForm.filename"></el-input>
            </el-form-item>
            <el-form-item label="资料索引" prop="dataindex">
                <el-input placeholder="请输入资料索引" v-model.trim="ruleForm.dataindex"></el-input>
            </el-form-item>
            <el-form-item label="资料" prop="enclosure">
                <uploadFiles ref="uploadFiles" :uploadType="uploadType" @setFile="_setFile" :fileRule="fileRule"></uploadFiles>
                <div>{{docinfo.fname}}</div>
                <p class="dataTips">建议上传ppt、pdf格式， 文件大小不能超过1G。</p>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="sureEvent">确认</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import UploadFiles from 'base/upload/uploadFile.vue'
    import {saveCourseDocInfo} from 'api/curriculumApi'
    import {mapActions} from 'vuex'
    import {formatFileInfo} from 'common/js/tools'
    export default {
        name: "uploadData",
        data(){
            return{
                dialogVisible:false,
                docinfo:{
                    bucket: '',
                    fname: '',
                    fsize: '',
                    furl: '',
                    key: '',
                    keyid: '',
                    mimetype: '',
                    type: 'add',
                    vsource: 1
                }, // 资料json串
                ruleForm:{
                    courseid:this.$route.query.innerid, // 课程id
                    filename:'', // 资料名称
                    docinfo:'', // 资料json串
                    dataindex: 1 // 资料索引
                },
                rules: {
                    enclosure: [
                        {required: true, message: '请选择', trigger: 'change'}
                    ],
                    dataindex: [
                        {required: true, message: '请输入资料索引', trigger: 'change'}
                    ]
                },
                fileRule: {
                    btnName: '选择文件',
                    showFileFist: true,
                    multiple: true,
                    cls: '',
                    accept: '',
                    size: 2 * 1024,
                    width: '',
                    height: ''
                },
                uploadType: {
                    catecode: '95',
                    datatype: 'FILE'
                },
            }
        },
        mounted(){

        },
        methods:{
            open(){
                this.dialogVisible=true
                this.ruleForm.filename=''
                this.ruleForm.docinfo=''
                this.ruleForm.dataindex=1
                this.docinfo.key=''
                this.docinfo.fname=''
            },
            beforeClose() {
                this.$refs.uploadFiles.emptyUploadSetting()
                this.dialogVisible = false
            },
            sureEvent(){
                if (!this.ruleForm.dataindex) {
                    this.$message({
                        message: '请输入资料索引',
                        type: 'warning'
                    });
                    return
                }
                if(!this.docinfo.key) {
                    this.$message({
                        message: '请上传文件',
                        type: 'warning'
                    });
                    return
                }
                this.ruleForm.docinfo = formatFileInfo(this.docinfo)
                this.setLoading(true)
                saveCourseDocInfo({
                    data: Object.assign({}, this.ruleForm),
                    success: data => {
                        this.beforeClose()
                        this.$emit('getList')
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })

            },
            _setFile(file) {
                console.log(file)
                this.docinfo = file
            },
            ...mapActions([
                'setLoading',
            ])
        },
        components:{
            UploadFiles
        }
    }
</script>

<style lang="scss">
    .el-dialog .el-button{
        margin-bottom: 0;
    }
    .dataTips{
        color: #C0C4CC;
        line-height: 25px
    }
</style>
